import {inject}               from '@angular/core';
import {FirebaseToolsService} from '../firebase/firebase-tools.service';

export abstract class DataFactoryBase {
	public svcFirebaseTools = inject(FirebaseToolsService);

	abstract initializeData(): Promise<void>
}
